import { render, staticRenderFns } from "./VdoSetTopicEditBunny.vue?vue&type=template&id=536c24a8&scoped=true&"
import script from "./VdoSetTopicEditBunny.vue?vue&type=script&lang=js&"
export * from "./VdoSetTopicEditBunny.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536c24a8",
  null
  
)

export default component.exports